// extracted by mini-css-extract-plugin
export default {"container":"score_container__FMYKF"};